<template lang="pug">
  .service-container
    .service-container__header.service-container__header__bg1
      .service-container__title {{ $t('营销跨渠道投放表现效果评估') }}
      .service-container__desc {{ $t('帮助企业详细评估各个营销渠道表现，通过集团层级、媒介渠道、媒体、地域、供应商等维度做交叉分析，使得ROI最大化。某出行集团通过该服务管理分析5个大类媒介资源下的60个线上线下媒体的数据表现。') }}
    .service-content-container
      .service-container__subTitle
        img(src="@/assets/icon-challenge.png")
        .subTitle {{ $t('企业面临的挑战与痛点') }}

      .service-challenge-container.service-challenge-container__min
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconshujufensan
          .item__title {{ $t('营销资产碎片化') }}
          .item__desc {{ $t('所有业务数据都是割裂的，且分散在不同部门，所有营销数据通过PPT、Excel存储，没有进行数字化，相关组织协作问题导致内部低效。') }}
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconxiaoshuai
          .item__title {{ $t('营销投入无法追踪') }}
          .item__desc {{ $t('企业缺乏跨媒体渠道和用户数据的收集，缺乏对策略制定及有效性衡量的洞察力，缺乏市场及竞争对手的市场基准，相关数据无法追踪及衡量的问题导致外部低效。') }}
      .service-container__subTitle
        img(src="@/assets/icon-project.png")
        .subTitle {{ $t('复歌的解决方案') }}

      .service-solution-container
        .solution-item
          .solution-content
            .solution-content__title {{ $t('广告数据整合') }}
            .solution-content__desc {{ $t('用户在iMedia Tracker中一键上传排期，极速导入各渠道如：数字媒体、电视、电台广播、报纸杂志、室内户外等广告排期，获取排期数据，同时用户导入广告投后效果数据，计划与实际数据对比一目了然。另外用户也可在对应的广告活动中上传各类创意素材及客户确认文件，无论是投放数据还是物料信息，均可以有效准确的存储并查询。')}}
            .solution-content__link(
              @click="$router.push('/product/i_media_tracker')"
            )
              img(src="@/assets/logo-tracker.png")
              span iMedia Tracker
              img.icon-entrance(src="@/assets/icon-entrance.png")
          img(
            src="@/assets/service-effect-1.png"
          )
        .solution-item
          .solution-content
            .solution-content__title {{ $t('投放效果评估') }}
            .solution-content__desc {{ $t('无论是企业决策层或是执行层，均通过iMedia Tracker丰富强大的数据分析功能，生成相关图表分析，助力跨媒体渠道、公司组织架构、地域、供应商生成分析报告，辅助日后营销策略的制定以及广告有效性洞察进一步提升。') }}
          img(
            src="@/assets/service-effect-2.png"
          )
    MobileCaseSample(
      :data="caseList"
    )
    mobile-contact
</template>

<script>
import MobileContact from '@/components/MobileContact'
import MobileCaseSample from '@/components/MobileCaseSample'

export default {
  components: {
    MobileContact,
    MobileCaseSample
  },
  data () {
    return {
      caseList: [
        {
          url: '/case/effect-evaluation',
          img: require('@/assets/case-effect.jpg'),
          title: '某出行平台',
          desc: '为该企业市场部搭建媒介数据管理系统，高效整合、对比、分析数据。'
        }
      ]
    }
  }
}
</script>
